export const EVENTS_PER_PAGE_HOME = 9;
export const EVENTS_PER_PAGE_COLLECTION = 20;
